import React, { useEffect, useRef } from 'react';
import styles from "./ModalHeader.styles";
import { AppBar, Toolbar, Typography, Tooltip } from "@mui/material";

interface ModalHeaderProps {
  title: string;
  email?: string;
}

export default function ModalHeader({ title, email }: ModalHeaderProps) {
  const emailRef = useRef<HTMLDivElement | null>(null);
  const [truncated, setTruncated] = React.useState(false);
  useEffect(() => {
    const element = emailRef.current;
    if (!element) return;
    const checkOverflow = () => {
      setTruncated(element.scrollWidth > element.clientWidth);
    };
    checkOverflow();
    window.addEventListener("resize", checkOverflow);
    return () => window.removeEventListener("resize", checkOverflow);
  }, [email]);
  return (
    <AppBar position="relative" sx={styles.dataApp}>
      <Toolbar
        sx={{
          ...styles.toolbar,
          justifyContent: email ? "space-between" : "center",
        }}
      >
        <Typography sx={styles.headerContent} noWrap>
          {title}
        </Typography>
        {email && (
          <Tooltip
            title={truncated ? email : ""}
            placement="right"
          >
            <Typography
              ref={emailRef}
              sx={styles.email}
              noWrap
            >
              {email}
            </Typography>
          </Tooltip>
        )}
      </Toolbar>
    </AppBar>
  );
}
